export const variableColorPickerTheme = {
  colorPreview: {
    active: {
      borderColor: 'palette.tertiary.90',
      borderRadius: '6px',
      borderWidth: '3px',
      text: 'palette.tertiary.80',
    },
    base: {
      borderColor: 'palette.neutral.40',
      borderRadius: '6px',
      borderWidth: '1px',
      text: 'palette.tertiary.50',
    },
  },
  gradientControl: {
    thumb: {
      active: {
        borderColor: 'palette.tertiary.80',
        borderRadius: '8px',
      },
      base: {
        borderColor: 'palette.neutral.40',
        borderRadius: '8px',
      },
    },
  },
  saturationBox: {
    pointer: {
      borderColor: 'palette.primary.99',
      borderRadius: '12px',
      borderWidth: '2px',
    },
  },
};
